import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { createEmptyCart } from "../../actions";
import ProductItem from "../ProductItem";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useProductsByCategory } from "../../hooks/useAmplifyData";

const CategoryPage = () => {
  const dispatch = useDispatch();
  const { id: categoryId } = useParams();
  const auth = useSelector(state => state.auth);
  const category = useSelector(state => state.category.category);

  // Amplify Gen 2 hook for fetching category products
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    error,
    refetch
  } = useProductsByCategory(parseInt(categoryId), 20);

  // Flatten paginated results into single array
  const products = data?.pages.flatMap(page => page?.items || []) || [];

  // Debug logging
  console.log('CategoryPage Debug:', {
    categoryId,
    isLoading,
    error,
    data,
    products,
    productCount: products?.length,
    firstProduct: products?.[0]
  });

  useEffect(() => {
    if (auth.is_signed_in) {
      dispatch(createEmptyCart());
    }
  }, [auth.is_signed_in, dispatch]);

  // Refetch when category changes
  useEffect(() => {
    refetch();
  }, [categoryId, refetch]);

  const renderProducts = () => {
    return products.map(product => (
      <ProductItem
        key={product.product_id}
        product={{
          // Map DynamoDB fields to expected format
          id: product.product_id,
          name: product.product_name,
          sku: product.sku,
          price: product.price,
          image: product.image_url,
          images: product.images || [],
          qty: product.quantity || 0,
          type_id: product.is_gift_card ? 'giftcard' : product.product_type,
          is_giftcard: product.is_gift_card,
          seller_id: product.seller_id,
        }}
      />
    ));
  };

  if (error) {
    return (
      <div>
        <h1 className="h1">Error</h1>
        <div className="explanatory-text">Failed to load products. Please try again.</div>
      </div>
    );
  }

  const categoryName = category?.name || 'Category';

  return (
    <div id="page-category">
      <h1 className="h1">{categoryName}</h1>
      <div className="product-tile-parent">
        {isLoading && products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>Loading products...</div>
        ) : (
          <InfiniteScroll
            dataLength={products.length}
            next={fetchNextPage}
            hasMore={hasNextPage || false}
            loader={null}
            endMessage={
              <p style={{
                fontWeight: '400',
                textAlign: 'center',
                fontSize: '18px',
                clear: 'both'
              }} className="up-to-date">
                {products.length === 0 ? 'No Products Found' : 'No More Products'}
              </p>
            }
          >
            <div className="product-grid">
              {renderProducts()}
            </div>
          </InfiniteScroll>
        )}
      </div>
      <div className="clear"></div>
    </div>
  );
};

export default CategoryPage;
